module.exports = __webpack_public_path__ + "img/sidekick-grid.de82bdf0.png";